(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pwa-install-button"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var deferredPrompt = null;
    var buttons = document.querySelectorAll('[data-pwa-install]');

    if (!buttons.length) {
      return;
    }

    window.addEventListener('beforeinstallprompt', function (event) {
      event.preventDefault();
      deferredPrompt = event;
      buttons.forEach(function (button) {
        button.hidden = false;
      });
    });

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (!deferredPrompt) {
          return;
        }
        deferredPrompt.prompt();
        deferredPrompt.userChoice.then(function () {
          deferredPrompt = null;
          button.hidden = true;
        });
      });
    });

    window.addEventListener('appinstalled', function () {
      buttons.forEach(function (button) {
        button.hidden = true;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
